/**
 * Sound alert generator using Web Audio API.
 * Plays 3 loud "ding-dong" beeps to grab attention in the kitchen.
 */
let audioContext = null;

export function initAudio() {
  if (audioContext) return audioContext;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    audioContext = new Ctx();
    // resume if suspended (autoplay policy)
    if (audioContext.state === "suspended") audioContext.resume();
    return audioContext;
  } catch {
    return null;
  }
}

function beep(ctx, freq, when, dur, vol = 0.45) {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = "sine";
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0.0001, ctx.currentTime + when);
  gain.gain.exponentialRampToValueAtTime(vol, ctx.currentTime + when + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + when + dur);
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(ctx.currentTime + when);
  osc.stop(ctx.currentTime + when + dur + 0.05);
}

export function playAlert(times = 3) {
  const ctx = initAudio();
  if (!ctx) return;
  if (ctx.state === "suspended") ctx.resume();
  const pattern = [880, 1175];
  for (let r = 0; r < times; r++) {
    const base = r * 0.9;
    pattern.forEach((f, i) => beep(ctx, f, base + i * 0.35, 0.35));
  }
}
